import React from "react";
import { User } from "~/modules/user/store/types";
import { useUser } from "../../hooks/useUser";

// // // //

interface State {
    loading: boolean;
    error: boolean;
    user: User;
}

/**
 * UserFetcher
 * Fetches current user via api
 * NOTE - this function can likely be phased out in favor of implementing the useUser hook directly
 */
export function UserFetcher(props: {
    children: (state: State) => React.ReactNode;
}) {
    // Setup useUser hook to return pre-fetched user state
    const { loading, error, user } = useUser();

    // Expose state via props.children
    return (
        <React.Fragment>
            {props.children({
                loading,
                user,
                error: !!error,
            })}
        </React.Fragment>
    );
}
